module.exports = __webpack_public_path__ + "img/dots-orange-3x6.65a2f1c2.svg";